import { useState, useMemo, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { isEqual } from 'lodash'

import { getViewRecords } from '../../../../../../data/dataServices'
import {
	getSelectedProject,
	getViewClientFilters,
} from '../../../../../../../components/data/dataHelpers'
import {
	getAllColumnsByView,
	PROJECT_FORM_VIEW_TYPE,
} from 'components/data/datagrid/CreatViewComponents/ViewDialogUtils'
import { HIDDEN_COLUMNS } from '../constant'

export function useJobSummaryViewReducer(props) {
	const { formKey, projectKey, columnsChecked, tile } = props

	const { environment } = useSelector((state) => state)

	const [viewData, setViewData] = useState(null)
	const [allColumns, setAllColumns] = useState([])
	const [serverFilter, setServerFilter] = useState({})

	const enabled = useMemo(() => {
		return Boolean(projectKey) && Boolean(formKey)
	}, [projectKey, formKey])

	const {
		data,
		isLoading: viewLoading,
		isFetching: viewFetching,
		refetch: reloadViews,
	} = useQuery({
		queryKey: ['jobSummaryView', tile?.key, formKey, projectKey],
		queryFn: () => getViewRecords(formKey, projectKey, false, environment?.apiToken),
		enabled,
	})

	const { data: allColumnsReponse, isLoading: allColumnsLoading } = useQuery({
		queryKey: ['jobSummaryView', 'allColumns', formKey, projectKey],
		queryFn: () =>
			getAllColumnsByView({
				viewDataType: PROJECT_FORM_VIEW_TYPE,
				apiToken: environment?.apiToken,
				formKey,
			}),
		enabled,
	})
	useEffect(() => {
		if (viewFetching) return
		const viewData = data?.data
		setViewData(viewData)

		const clientFilter = viewData?.clientFilter ? JSON.parse(viewData?.clientFilter) : undefined

		const currentFiltersWithUserFilter = getViewClientFilters(
			clientFilter,
			environment?.userCurrent?.dataGroupKey
		)
		if (!isEqual(serverFilter, currentFiltersWithUserFilter)) {
			setServerFilter(currentFiltersWithUserFilter)
		}
	}, [viewFetching, data])

	useEffect(() => {
		if (allColumnsLoading) return

		const availableColumns = (allColumnsReponse || []).filter(
			(col) => !HIDDEN_COLUMNS.includes(col.name)
		)
		setAllColumns(availableColumns || [])
	}, [allColumnsReponse, allColumnsLoading])

	return {
		viewData,
		allColumns,
		serverFilter,
		viewLoading: viewFetching,
		reloadViews,
	}
}
